import { __awaiter, __generator } from "tslib";
import { launchUrl } from './launchUrl';
import { logClick } from './logClick';
export function launchUrlInWeb(action, webUrl, launchInstrumentationParams, linkTarget) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var launchResult;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, , 2, 3]);
                    return [4 /*yield*/, launchUrl(webUrl, { action: action, linkTarget: linkTarget })];
                case 1:
                    launchResult = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    logClick({
                        launchInstrumentationParams: launchInstrumentationParams,
                        success: (_a = launchResult === null || launchResult === void 0 ? void 0 : launchResult.success) !== null && _a !== void 0 ? _a : false,
                        platform: 'Web',
                    });
                    return [7 /*endfinally*/];
                case 3: return [2 /*return*/, launchResult];
            }
        });
    });
}
//# sourceMappingURL=launchUrlInWeb.js.map